import set from 'lodash/set';

import trimInputSpaces from '../../utils/trim-input-spaces';

/**
 * form mutation ad validation without determining fields with errors. valid = true | false;
 *
 * @param {*} formData 
 * @param {*} key 
 * @param {*} value 
 */
export default function payoutEftMutations(formData, key, value) {
  const nextValue = trimInputSpaces(value);

  set(formData, key, nextValue);

  // update dependant fields
  switch (key) {
    default:
  }

  return formData;
}
